import React from "react";
import { Link, useLocation } from "react-router-dom";

function Breadclumbs() {
  let { pathname } = useLocation();
  return (
    <section className="breadclumb">
      <div className="breadclumb-text">
        <Link to={"/"}> Home - </Link>
        <span className="page">{pathname.slice(1)}</span>
      </div>
    </section>
  );
}

export default Breadclumbs;
